export enum DocumentTypeIdEnum {
  BANK_STATEMENT_ID = '8edbb712-9d05-4e7e-a9cd-25323887255a',
  SECOND_BANK_STATEMENT_ID = '3e8b0838-76d0-411a-81a7-227987c0033d',
  PROOF_OF_ADDRESS_ID = '33af2266-0de0-442d-82bd-ed65495328b0',
  PROOF_OF_FISCAL_ADDRESS_ID = '5f767168-e0dd-499c-96bb-e361df4e78a2',
}
